import { render, staticRenderFns } from "./GerarDocNotaTravadaModal.vue?vue&type=template&id=84d8a096"
import script from "./GerarDocNotaTravadaModal.vue?vue&type=script&lang=js"
export * from "./GerarDocNotaTravadaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports